<template>
  <div id="liveConsole" class="liveconsole">
    <div class="columns liveconsole__inner">
      <div class="column">
        <div class="video">
          <div class="video__inner">
            <Video :liveUrl="playbackUrl" />
          </div>
        </div>
        <div class="liveparts">
          <ul class="liveinfo">
            <li class="liveinfo__item">配信時間 {{ streamingTime }} 経過</li>
            <li class="liveinfo__item">現在パトロン {{ patronsAmount }} 人</li>
            <li class="liveinfo__item">配信予定を確認する</li>
          </ul>

          <b-collapse
            aria-id="contentIdForA11y2"
            class="panel"
            animation="slide"
          >
            <template #trigger>
              <div
                class="panel-heading"
                role="button"
                aria-controls="contentIdForA11y2"
              >
                <p>コントロールパネル</p>
              </div>
            </template>
            <div class="panel-block">
              <div class="buttons">
                <b-button
                  class="button is-primary"
                  :disabled="isStreaming"
                  @click.native="resetStreamKey"
                >
                  Stream Key 更新
                </b-button>
                <b-button
                  class="button is-primary"
                  :disabled="!(ableStartStreaming && !isStreaming)"
                  @click.native="startStreaming"
                >
                  配信開始
                </b-button>
                <b-button
                  class="button is-primary"
                  :disabled="!(ableEndStreaming && isStreaming)"
                  @click.native="endStreaming"
                >
                  配信終了
                </b-button>
              </div>
              <div class="columns">
                <div class="column">
                  <b-field label="Url">
                    <b-input
                      type="text"
                      id="ingestEndpoint"
                      :value="ingestEndpoint"
                      readonly
                      expanded
                    />
                    <p class="control">
                      <b-button
                        class="button is-primary"
                        @click="copyValue('ingestEndpoint')"
                        >Copy</b-button
                      >
                    </p>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Stream Key">
                    <b-input
                      type="text"
                      id="streamKey"
                      :value="streamKey"
                      readonly
                      expanded
                    />
                    <p class="control">
                      <b-button
                        class="button is-primary"
                        @click="copyValue('streamKey')"
                        >Copy</b-button
                      >
                    </p>
                  </b-field>
                </div>
              </div>
            </div>
          </b-collapse>
        </div>
      </div>

      <div class="column is-one-third-desktop">
        <div class="comment">
          <div class="comment__display">
            <div
              class="media"
              v-for="(comment, index) in comments"
              :key="index"
            >
              <figure class="media-left">
                <div class="image">
                  <b-image
                    :src="comment.photoURL"
                    ratio="1by1"
                    :rounded="true"
                  />
                </div>
              </figure>
              <div v-if="comment.type == 'comment'" class="media-content">
                <div class="content">
                  <p>
                    <strong>{{ comment.nickname }}</strong>
                    <br />
                    {{ comment.message }}
                    <br />
                  </p>
                </div>
              </div>
              <div
                v-if="comment.type == 'gift'"
                class="media-content gift-content"
              >
                <div class="content">
                  <strong>{{ comment.nickname }}</strong>
                  <br />
                  <figure class="gift-icon-container">
                    <img :src="comment.iconURL" class="gift-icon" />
                  </figure>
                  <p class="gift-message">
                    "{{ comment.giftNameJP }}"が届きました！
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as liveServices from '@/services/liveServices';
import Video from '@/components/Video';
import LiveRegistrationFormModal from '@/components/LiveRegistrationFormModal';

export default {
  name: 'LiveConsole',
  components: {
    Video
  },
  data() {
    return {
      userData: null,
      ivsChannelInfo: {},
      liveId: this.$route.params.liveId,
      streamingTime: '00:00:00',
      patronsAmount: 0,
      comments: [],
      donations: []
    };
  },
  async created() {
    if (this.liveId && !this.$store.state.user.isStreaming) {
      await this.$store.dispatch('live/loadUpComingLive', this.liveId);
    } else if (this.liveId && this.$store.state.user.isStreaming) {
      await this.$store.dispatch('live/loadRecentLive', this.liveId);
    }
    // load comment
    if (!this.liveId) return;
    this.commentRefObj = await liveServices.getLiveCommentRefObj(
      this.$route.params.liveId
    );
    let that = this;
    this.commentRefObj
      .orderByChild('timestamp')
      .limitToLast(100)
      .on('child_added', function (snap) {
        that.comments.push(snap.val());
        if (that.comments.length > 100) that.comments.splice(0, 1);
      });
  },
  computed: {
    isPerformer() {
      return this.$store.getters['user/isPerformer'];
    },
    isStreaming() {
      return this.$store.getters['user/isStreaming'];
    },
    ableStartStreaming() {
      return this.$store.getters['ivs/ableStartStreaming'];
    },
    ableEndStreaming() {
      return this.$store.getters['ivs/ableEndStreaming'];
    },
    streamKey() {
      return this.$store.state.ivs.streamKey.value;
    },
    playbackUrl() {
      return this.$store.state.ivs.channel.playbackUrl;
    },
    ingestEndpoint() {
      return this.$store.state.ivs.channel.ingestEndpoint
        ? `rtmps://${this.$store.state.ivs.channel.ingestEndpoint}:443/app/`
        : '';
    }
  },
  updated() {
    this.scrollToEnd();
  },
  methods: {
    scrollToEnd() {
      const container = document.querySelector('.comment__display');
      container.scrollTop = container.scrollHeight;
    },
    async resetStreamKey() {
      try {
        this.$store.dispatch('resetStreamKey', {
          userId: this.$store.state.auth.uid,
          channelArn: this.$store.state.user.ivsChannelArn,
          streamKeyArn: this.$store.state.user.ivsStreamKeyArn
        });
        this.$buefy.toast.open({
          message: 'Reset Sream Key successfully!',
          type: 'is-success'
        });
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async startStreaming() {
      // handle if liveId is not exist
      if (!this.liveId) {
        this.$buefy.modal.open({
          parent: this,
          component: LiveRegistrationFormModal,
          hasModalCard: true,
          trapFocus: true
        });
        return;
      }

      try {
        const upComingLive = this.$store.state.live.upComingLive;
        const liveDoc = {
          userId: this.$store.state.auth.uid,
          title: upComingLive.title,
          aboutLive: upComingLive.aboutLive,
          thumbnailUrl: upComingLive.thumbnailUrl,
          playbackUrl: this.$store.state.ivs.channel.playbackUrl,
          startAt: upComingLive.startAt
        };
        this.$store.dispatch('startLiveStreaming', {
          userId: this.$store.state.auth.uid,
          liveId: this.liveId,
          liveDoc: liveDoc
        });
      } catch (err) {
        console.error(err);
        return;
      }
    },
    async endStreaming() {
      try {
        this.$store.dispatch('endStreaming', {
          userId: this.$store.state.auth.uid,
          liveId: this.$store.state.user.recentLiveId,
          liveDoc: this.$store.state.live.recentLive
        });
      } catch (err) {
        console.error(err);
        return;
      }
    },
    copyValue(inputId) {
      const inputElement = document.querySelector(`#${inputId}`);
      inputElement.select();
      try {
        document.execCommand('copy');
        this.$buefy.toast.open({
          message: 'Copied to clipboard',
          type: 'is-success'
        });
      } catch (err) {
        this.$buefy.toast.open({
          message: err.message,
          type: 'is-danger'
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-console.scss';
</style>
